/* ============================================================
   Pasta Bench - theme behaviour.

   What survived the move from the local site: the category tabs,
   the quantity stepper, the toast, and the About photo strip with
   its measured pace and its decode warm-up.

   What did not, because Shopify does it natively: the whole batch
   state layer, the localStorage cart, and the admin screen.
   ============================================================ */

/* ---------- toast ---------- */
let toastTimer;
function say(msg){
  const el = document.getElementById('toast');
  if (!el) return;
  el.textContent = msg;
  el.setAttribute('data-on', 'true');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => el.setAttribute('data-on', 'false'), 3200);
}

/* ---------- category tabs (This Week, Our Pasta) ----------
   Same behaviour as the approved site: one category at a time, the
   choice kept in the URL so a link can point straight at it. */
function initTabs(scope){
  const wrap = scope.querySelector('[data-tabs]');
  const body = scope.querySelector('[data-tab-body]');
  if (!wrap || !body) return;

  const groups = [...body.querySelectorAll('[data-type-group]')];
  const params = new URLSearchParams(location.search);
  let current = params.get('type') || (groups[0] && groups[0].dataset.typeGroup) || '';

  function show(key){
    current = key;
    groups.forEach(g => { g.hidden = g.dataset.typeGroup !== key; });
    wrap.querySelectorAll('[data-tab]').forEach(b => {
      const on = b.dataset.tab === key;
      b.setAttribute('aria-selected', String(on));
      b.classList.toggle('is-on', on);
    });
    const u = new URL(location.href);
    u.searchParams.set('type', key);
    history.replaceState(null, '', u);
  }

  wrap.addEventListener('click', e => {
    const b = e.target.closest('[data-tab]');
    if (b) show(b.dataset.tab);
  });

  if (groups.length) show(groups.some(g => g.dataset.typeGroup === current) ? current : groups[0].dataset.typeGroup);
}

/* ---------- quantity stepper ---------- */
document.addEventListener('click', e => {
  const step = e.target.closest('[data-step]');
  if (!step) return;
  const input = step.parentElement.querySelector('input[name="quantity"], input[data-qty]');
  if (!input) return;
  const next = Math.max(1, Math.min(20, (parseInt(input.value, 10) || 1) + parseInt(step.dataset.step, 10)));
  input.value = next;
});

/* ---------- add to cart ----------
   Posts to Shopify and updates the header count without a reload. If
   anything goes wrong the form submits normally, so the button still
   works with JavaScript broken. */
document.addEventListener('submit', async e => {
  const form = e.target.closest('form[data-add-to-cart]');
  if (!form) return;
  e.preventDefault();
  const btn = form.querySelector('[type="submit"]');
  if (btn) btn.disabled = true;
  try {
    const res = await fetch('/cart/add.js', { method:'POST', body:new FormData(form),
      headers:{ 'Accept':'application/json' } });
    if (!res.ok) throw new Error(await res.text());
    const item = await res.json();
    await refreshCartCount();
    say(`${item.product_title} added to your cart.`);
  } catch (err) {
    form.removeAttribute('data-add-to-cart');
    form.submit();
    return;
  }
  if (btn) btn.disabled = false;
});

async function refreshCartCount(){
  const el = document.getElementById('cartCount');
  if (!el) return;
  try {
    const cart = await (await fetch('/cart.js', { headers:{ 'Accept':'application/json' } })).json();
    el.textContent = cart.item_count;
    el.setAttribute('data-empty', String(cart.item_count === 0));
  } catch (e){}
}

/* ---------- mobile menu ----------
   The panel is shown by CSS off one attribute on the header, so there is a
   single source of truth and nothing to get out of step. */
function setNav(open){
  const head = document.querySelector('.head');
  const btn = document.querySelector('.nav-toggle');
  if (!head || !btn) return;
  head.setAttribute('data-nav-open', String(open));
  btn.setAttribute('aria-expanded', String(open));
}
document.addEventListener('click', e => {
  const btn = e.target.closest('.nav-toggle');
  if (btn){
    setNav(btn.getAttribute('aria-expanded') !== 'true');
    return;
  }
  /* tapping the scrim, or following a link, closes it */
  if (e.target.closest('.nav-scrim') || e.target.closest('.menu a')) setNav(false);
});
document.addEventListener('keydown', e => {
  if (e.key !== 'Escape') return;
  const head = document.querySelector('.head');
  if (head && head.getAttribute('data-nav-open') === 'true'){
    setNav(false);
    const btn = document.querySelector('.nav-toggle');
    if (btn) btn.focus();                 // don't strand the keyboard
  }
});
/* Turning the phone, or moving to a wide window, leaves the panel orphaned
   because the CSS that shows it no longer applies. */
window.addEventListener('resize', () => {
  if (window.innerWidth > 820) setNav(false);
});

/* ---------- Our Pasta row controls ----------
   The row is a CSS animation, so the honest way to step it is to move the
   animation's own clock rather than fight it with a competing transform:
   the loop stays seamless and the hover behaviour is untouched.

   One tile of travel is (tile width + gap) out of half the track - half,
   because the track holds the set twice and the keyframes run to -50%. */
document.addEventListener('click', e => {
  const btn = e.target.closest('[data-marquee-step]');
  if (!btn) return;
  const marquee = btn.closest('.marquee');
  const track = marquee && marquee.querySelector('.marquee__track');
  if (!track) return;

  const anim = track.getAnimations()[0];
  if (!anim || !anim.effect) return;
  const total = anim.effect.getTiming().duration;          // ms for one loop
  if (!total) return;

  const tile = track.querySelector('.tile');
  const cs = getComputedStyle(track);
  const gap = parseFloat(cs.columnGap || cs.gap) || 0;
  const half = track.getBoundingClientRect().width / 2;
  if (!tile || !half) return;
  const step = (tile.getBoundingClientRect().width + gap) / half * total;

  let t = (Number(anim.currentTime) || 0) + step * Number(btn.dataset.marqueeStep);
  t = ((t % total) + total) % total;                       // wrap, never negative
  anim.currentTime = t;

  /* Hold it there. Without this the row keeps drifting under the pointer and
     slides away from the tile you just lined up. Set inline rather than with
     a class: an inline style beats the :hover rule outright, and this
     stylesheet has a history of specificity ties. */
  track.style.animationPlayState = 'paused';
});

/* Moving the pointer off the row hands it back to CSS, so the next hover
   drifts again as before. */
document.addEventListener('mouseout', e => {
  const marquee = e.target.closest && e.target.closest('.marquee');
  if (!marquee) return;
  if (e.relatedTarget && marquee.contains(e.relatedTarget)) return;  // still inside
  const track = marquee.querySelector('.marquee__track');
  if (track) track.style.animationPlayState = '';
});

/* ---------- About photo strip ----------
   A constant speed in px/sec; the loop length follows from the measured
   width of one set, so adding photographs changes how long a loop takes
   and never how fast it moves. */
const STRIP_PPS = 88;
function sizeStrip(){
  document.querySelectorAll('.strip').forEach(el => {
    const set = el.querySelector('.strip__set');
    if (!set) return;
    const w = set.getBoundingClientRect().width;
    if (w > 0) el.style.setProperty('--strip-dur', (w / STRIP_PPS).toFixed(2) + 's');
  });
}

/* Decode every photograph up front. Without this the rasteriser meets an
   undecoded image as a frame scrolls in, defers it, and paints a flat
   colour in its place until the decode lands - a visible blink. Found in
   a Chrome trace on the approved site; the fix travels with the strip. */
function warmStrip(){
  document.querySelectorAll('.strip img').forEach(im => {
    if (im.decode) im.decode().catch(() => {});
  });
}

/* ---------- boot ---------- */
function boot(scope){
  initTabs(scope || document);
  sizeStrip();
  warmStrip();
}
boot(document);
window.addEventListener('resize', sizeStrip);

/* the theme editor swaps sections in and out without a reload */
document.addEventListener('shopify:section:load', e => boot(e.target));

const yr = document.getElementById('yr');
if (yr) yr.textContent = new Date().getFullYear();
